import React, { ReactNode } from 'react';

import * as S from './styles';

interface IProps {
  /** Exactly two fields: the English one first, then the Arabic one. */
  children: ReactNode;
  className?: string;
  style?: object;
}

/**
 * A bilingual field pair.
 *
 *   <FieldPair>
 *     <TextIput label="Item title" langTag="EN" ... />
 *     <TextIput label="Item title" langTag="AR" dir="rtl" ... />
 *   </FieldPair>
 *
 * The Arabic side carries `dir="rtl"`, which `ctrlBase` turns into
 * --font-ar and right alignment. The label stays English and LTR — the panel
 * chrome is not translated, only the content being authored is.
 */
const FieldPair: React.FC<IProps> = ({ children, className, style }) => (
  <S.Pair className={className} style={style}>
    {children}
  </S.Pair>
);

export default FieldPair;
